import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UiService } from './ui.service';

@Injectable({ providedIn: 'root' })
export class TllLoginRedirectService {
  private readonly ui = inject(UiService);

  shouldRedirectGuestToLogin(): boolean {
    return environment.brand === 'tll' && environment.features?.redirectLogin === true;
  }

  redirectToLogin(): void {
    this.ui.openSignInModal();
  }
}